module.exports = __webpack_public_path__ + "img/festival_chinesenewyear1.a0b0e638.png";